import React, { memo } from 'react'
import Skeleton from 'react-loading-skeleton'
import { colors } from 'src/theme/colors'
import {TeachersSkeleton} from "src/components/Skeleton/teachers";
import {TeacherWrapper} from './styles'

function TeacherSkeletonComponent() {
  return (
    <TeacherWrapper>
      <div className="player-container">
        <Skeleton className="player" baseColor={colors.palette.neutral500} />
      </div>

      <div className="info">
        <Skeleton height={37} width="20%" className="title-bio" baseColor={colors.palette.neutral500} />
        <Skeleton height={700} width="100%" className="box" baseColor={colors.palette.neutral500} />
        <Skeleton height={37} width="40%" className="title-alternative" baseColor={colors.palette.neutral500} />
        <Skeleton height={300} width="100%" className="box" baseColor={colors.palette.neutral500} />
        <Skeleton height={37} width="30%" className="title-alternative" baseColor={colors.palette.neutral500} />
        <div className="box">
          <TeachersSkeleton />
        </div>
      </div>
    </TeacherWrapper>
  )
}

export const TeacherSkeleton = memo(TeacherSkeletonComponent)
